<template>
  <div class="loc-product-description">
    <p class="is-size-16px has-text-weight-semibold mb10">Description</p>
    <div v-html="description">
    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';
import Env from '@/env';

export default {
  name: 'LocationProductDescription',
  data() {
    return {
      variants: this.productvariants,
      selectedVariant: {},
      qty: 1,
    };
  },
  
  props:{
    description: {
      required: true,
      type: String,
    },
  },


  mounted() {

  },
  
  methods: {

  

  },
};
</script>
